import ReactDOM from 'react-dom';

import './assets/styles/index.css';
import { App } from './App';

ReactDOM.render(<App />, document.getElementById('root'));
